import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "remixicon/fonts/remixicon.css";

const PersonalBelongingsForm = ({ formData, setFormData, handleChange }) => {
    // ✅ Handle belonging row change
    const handleBelongingChange = (index, value) => {
        const updatedBelongings = [...formData.belongings];
        updatedBelongings[index].name = value;
        setFormData((prev) => ({ ...prev, belongings: updatedBelongings }));
    };

    const addBelonging = () => {
        setFormData((prev) => ({
            ...prev,
            belongings: [...prev.belongings, { name: "" }],
        }));
    };

    const removeBelonging = (index) => {
        const updatedBelongings = [...formData.belongings];
        updatedBelongings.splice(index, 1);
        setFormData((prev) => ({ ...prev, belongings: updatedBelongings }));
    };

    return (
        <div  className="p-4">
            {/* Row 1 */}
            <div className="row mb-3">
                <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                        <input
                            type="text"
                            name="clientName"
                            className="form-control"
                            value={formData.clientName}
                            onChange={handleChange}
                            placeholder="Client Name"
                            required
                            readOnly={!!formData.patientId || !!formData.patient_id}
                        />
                        <label>Client Name</label>
                    </div>
                </div>

                {/* <div className="col-md-4">
                    <div className="form-floating form-floating-outline">
                        <input
                            type="text"
                            name="caregiverName"
                            className="form-control"
                            value={formData.caregiverName}
                            onChange={handleChange}
                            placeholder="Caregiver Name"
                        />
                        <label>Caregiver Name</label>
                    </div>
                </div> */}

                <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                        <select
                            name="relation"
                            className="form-select"
                            value={formData.relation}
                            onChange={handleChange}
                        >
                            <option value="">Select Relation</option>
                            <option value="Father">Father</option>
                            <option value="Mother">Mother</option>
                            <option value="Brother">Brother</option>
                            <option value="Sister">Sister</option>
                            <option value="Spouse">Spouse</option>
                            <option value="Guardian">Guardian</option>
                        </select>
                        <label>Relation with Client</label>
                    </div>
                </div>
            </div>

            {/* Row 2: Belongings */}
            <div className="row mb-3">
                <div className="col-md-12">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block my-3">
                        Belongings List
                    </small>
                    {formData.belongings.map((item, index) => (
                        <div
                            key={index}
                            className="row align-items-center mb-2 g-2 border rounded-3 p-2 bg-light-subtle"
                        >
                            <div className="col-md-1 text-center fw-semibold">
                                {index + 1}.
                            </div>
                            <div className="col-md-10">
                                <div className="form-floating form-floating-outline">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={item.name}
                                        onChange={(e) =>
                                            handleBelongingChange(index, e.target.value)
                                        }
                                        placeholder="Belonging Name"
                                        required
                                    />
                                    <label>Belonging Name</label>
                                </div>
                            </div>
                            <div className="col-md-1 text-end">
                                <button
                                    type="button"
                                    className="btn btn-outline-danger btn-lg"
                                    onClick={() => removeBelonging(index)}
                                    disabled={formData.belongings.length === 1}
                                >
                                    <i className="ri-close-line"></i>
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Add Button */}
            <div className="row mb-4">
                <div className="col-md-12 text-end">
                    <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={addBelonging}
                    >
                        <i className="ri-add-line me-1"></i> Add Belonging
                    </button>
                </div>
            </div>

            {/* Final Fields */}
            <div className="row">
                <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            name="relativeName"
                            className="form-control"
                            value={formData.relativeName}
                            onChange={handleChange}
                            placeholder="Relative Name"
                        />
                        <label>Relative Name</label>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            name="trhStaffName"
                            className="form-control"
                            value={formData.trhStaffName}
                            onChange={handleChange}
                            placeholder="TRH Staff Name"
                        />
                        <label>TRH Staff Name</label>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default PersonalBelongingsForm;
